/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Ateliere_Connect_Import_FailedInputs */



/**
* | output |
* | --- |
* | "Project Import Failed. {message}" |
*
* @param {Ateliere_Connect_Import_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_import_failed = /** @type {((inputs: Ateliere_Connect_Import_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Import_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l’importation du projet. ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Projektimport fehlgeschlagen. ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Importazione del progetto non riuscita. ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Импорт проекта не удался. ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error en la importación del proyecto. ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`项目导入失败。${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プロジェクトのインポートに失敗しました。${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रोजेक्ट आयात विफल। ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A importação do projeto falhou. ${i?.message}`)
	return /** @type {LocalizedString} */ (`Project Import Failed. ${i?.message}`)
});